<template>
  <div class="container page setbank-page">
    <van-nav-bar :title="$t('setting.bank_info')" class="custom-nav" :border="false">
      <template #left>
        <van-icon name="arrow-left" color="#e6b98a" size="24" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="wrapper">
      <div class="add-card" @click="toBindCard()" v-if="!is_bind">
        <van-icon name="plus" />
        <span>{{$t("setting.add_bank")}}</span>
      </div>

      <div class="bank-card-display" v-else>
        <div class="card-bg">
          <div class="card-top">
            <!--<van-icon name="card" class="card-icon" />-->
			
            <span class="bank-name"> {{$t("setting.band_account")}}{{this.bankInfo.bankinfo}}</span>
          </div>
          <div class="card-middle">
            <span class="card-number">{{ formatBankId(this.bankInfo.bankid) }}</span>
          </div>
          <div class="card-bottom">
            <div class="card-user">
              
              <span class="value">{{this.userInfo.name}}</span>
            </div>
            <van-icon name="checked" class="bind-success-icon" />
          </div>
        </div>
      </div>

      <div class="tips">
        <van-icon name="info-o" />
        {{$t("setting.bind_bank_tip")}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind:false,
      bankInfo:{},
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    formatBankId(id) {
      if (!id) return '';
      // 每4位加一个空格
      return id.replace(/(.{4})/g, '$1 ').trim();
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.bankInfo = res.data.info;
          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      // 移除未填写名称就跳转的限制
      this.$router.push({path:'/BindCard'});
      return true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.setbank-page {
  background-color: #1f1c1f;
  min-height: 100vh;
}

/* 导航栏暗金风格 */
.custom-nav {
  background-color: #2b2b2b !important;
  border-bottom: 2px solid #766350;
}
::v-deep .custom-nav .van-nav-bar__title {
  color: #e6b98a !important;
  font-size: 36px;
}
::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0 !important;
}

.wrapper {
  padding: 40px 30px;
}

.add-card {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e6b98a;
  background-color: #2b2b2b;
  border: 2px dashed #766350;
  border-radius: 20px;
  height: 200px;
  font-size: 32px;
  cursor: pointer;
  
  span {
    margin-left: 16px;
  }
}

.bank-card-display {
  width: 100%;
  perspective: 1000px;
}

.card-bg {
  background: linear-gradient(135deg, #d4a572, #a67c52);
  border-radius: 24px;
  padding: 40px;
  color: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -20%;
    width: 300px;
    height: 300px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
  }
}

.card-top {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  
  .card-icon {
    font-size: 48px;
    margin-right: 20px;
    color: rgba(255, 255, 255, 0.9);
  }
  
  .bank-name {
    font-size: 36px;
    font-weight: bold;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
  }
}

.card-middle {
  margin-bottom: 40px;
  
  .card-number {
    font-family: 'Courier New', Courier, monospace;
    font-size: 46px;
    letter-spacing: 4px;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.4);
  }
}

.card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  
  .card-user {
    display: flex;
    flex-direction: column;
    
    .label {
      font-size: 24px;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 8px;
      text-transform: uppercase;
    }
    
    .value {
      font-size: 32px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
  
  .bind-success-icon {
    font-size: 50px;
    color: rgba(255, 255, 255, 0.8);
  }
}

.tips {
  margin-top: 40px;
  font-size: 26px;
  color: #999;
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
  background: #242424;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #333;
  
  .van-icon {
    margin-right: 12px;
    margin-top: 4px;
    color: #e6b98a;
    font-size: 32px;
  }
}
</style>
